import {
  useAppSaveBarHandler,
  useAppSaveBarSync,
} from "@/modules/app-save-bar";
import {
  useDatasetsMutatorActions,
  useDatasetsMutatorStatus,
} from "@/modules/datasets/datasets-mutator";
import { useInterventionSectionRenderIndex } from "@/modules/intervention/intervention-section";

import { INTERVENTION_SECTION_SCOPE } from "./intervention-section-save-bar.constant";

const SCOPE = INTERVENTION_SECTION_SCOPE;

/**
 * Manages actions and state of the save bar in an intervention section
 *
 * - Handles save and cancel actions from save bar
 * - Synchronizes datasets mutator state with save bar state
 * - Forces remounting of dataset components on cancel click
 */
export const useInterventionSectionSaveBarHandler = () => {
  const { isDirty, isSaving } = useDatasetsMutatorStatus();
  const { saveMutations, cancelMutations } = useDatasetsMutatorActions();
  const { incrementIndex } = useInterventionSectionRenderIndex();

  const onSave = () => {
    saveMutations();
  };

  const onCancel = () => {
    cancelMutations();

    // Increment intervention section `renderIndex` on each click
    // to make sure datasets are re-mounted on cancel click.
    incrementIndex();
  };

  // Sync save bar
  useAppSaveBarHandler(SCOPE, { onSave, onCancel });
  useAppSaveBarSync(SCOPE, "dirty", isDirty);
  useAppSaveBarSync(SCOPE, "saving", isSaving);
};
